import DashboardLayout from "../components/Dashboard/Layout/DashboardLayout.vue";
import NotFound from "../components/GeneralViews/NotFoundPage.vue";

// Pages
import Login from "src/components/Dashboard/Views/Pages/Login.vue";
import ForgotPassword from "src/components/Dashboard/Views/Pages/ForgotPassword.vue";
import ResetPasswordForm from "src/components/Dashboard/Views/Pages/ResetPasswordForm.vue";
import Register from "src/components/Dashboard/Views/Pages/Register.vue";

const Overview = () =>
  import("src/components/Dashboard/Views/Dashboard/Overview.vue");
const CategoryList = () =>
  import("src/components/Dashboard/Views/Categories/CategoryList.vue");
const FormBuilder = () =>
  import("src/components/Dashboard/Views/FormBuilder/FormBuilder.vue");
const Forms = () =>
  import("src/components/Dashboard/Views/FormBuilder/Forms.vue");
const EditForm = () =>
  import("src/components/Dashboard/Views/FormBuilder/EditForm.vue");
const UserForm = () =>
  import("src/components/Dashboard/Views/FormBuilder/UserForm.vue");
const ViewAnswer = () =>
  import("src/components/Dashboard/Views/FormBuilder/ViewAnswer.vue");
const PageBuilderIndex = () =>
  import("src/components/Dashboard/Views/PageBuilder/index.vue");
const CreatePageTemplate = () =>
  import("src/components/Dashboard/Views/PageBuilder/newPageTemplate.vue");
const EditPageTemplate = () =>
  import("src/components/Dashboard/Views/PageBuilder/editPageTemplate.vue");
const FileManager = () =>
  import("src/components/Dashboard/Views/FileManager/index.vue");
const Users = () => import("src/components/Dashboard/Views/Users/index.vue");
const UserFields = () =>
  import("src/components/Dashboard/Views/UserFields/index.vue");
const CreateUserFields = () =>
  import("src/components/Dashboard/Views/UserFields/UserFieldBuilder.vue");
const PageContent = () =>
  import("src/components/Dashboard/Views/Page/pageContent.vue");
const PageContentEdit = () =>
  import("src/components/Dashboard/Views/Page/pageContentEdit.vue");
const IndexPages = () =>
  import("src/components/Dashboard/Views/Page/index.vue");
const FarmerContent = () =>
  import("src/components/Dashboard/Views/Farmers/farmersContent.vue");
const IndexFarmers = () =>
  import("src/components/Dashboard/Views/Farmers/index.vue");
const Trainer = () =>
  import("src/components/Dashboard/Views/Manager/Trainer/index.vue");
const Report = () =>
  import("src/components/Dashboard/Views/Manager/Report/Report.vue");
const Activation = () =>
  import("src/components/Dashboard/Views/Manager/Report/Activation.vue");
const Farmers = () =>
  import("src/components/Dashboard/Views/Manager/Report/Farmers.vue");
const FarmersDetails = () =>
  import("src/components/Dashboard/Views/Manager/Report/ViewFarmerDetails");
const Harvests = () =>
  import("src/components/Dashboard/Views/Manager/Report/Harvest.vue");
const ReportTrainer = () =>
  import("src/components/Dashboard/Views/Manager/Report/Trainer.vue");
const TrainerDetails = () =>
  import("src/components/Dashboard/Views/Manager/Report/ViewTrainerDetails.vue");
const Soilscans = () =>
  import("src/components/Dashboard/Views/Manager/Report/SoilScans.vue");
const SoilShowList = () =>
  import("src/components/Dashboard/Views/Manager/Report/ShowList.vue");
const ShowSoilMap = () =>
  import("src/components/Dashboard/Views/Manager/Report/ShowMap.vue");
const ViewSoilList = () =>
  import("src/components/Dashboard/Views/Manager/Report/ViewShowList.vue");
const SoilAdvise = () =>
  import("src/components/Dashboard/Views/Manager/Report/SoilAdvise.vue");
const Crops = () =>
  import("src/components/Dashboard/Views/Agrism/Crops/index.vue");
const CountryCrops = () =>
  import("src/components/Dashboard/Views/Agrism/Crops/CountryCrop.vue");
const Packages = () =>
  import("src/components/Dashboard/Views/Package/Packages.vue");
const ImportFarmers = () => 
  import("src/components/Dashboard/Views/Farmers/ImportFarmers.vue");

let loginPage = {
  path: "/login",
  name: "Login",
  component: Login
};

let registerPage = {
  path: "/register",
  name: "Register",
  component: Register
};

let RequestPasswordChangePage = {
  path: "/reset-password",
  name: "reset-password",
  component: ForgotPassword
};
let ResetPasswordPage = {
  path: "/reset-password/:token",
  name: "reset-password-form",
  component: ResetPasswordForm
};

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/overview",
    name: "dashboard",
    children: [
      {
        path: "overview",
        name: "Overview",
        component: Overview,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: "/farmers",
    component: DashboardLayout,
    redirect: "/farmers/list",
    children: [
      {
        path: "list",
        name: "Farmers",
        component: IndexFarmers,
        meta: { requiresAuth: true }
      },
      {
        path: "content",
        name: "FarmerContent",
        component: FarmerContent,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: "/page",
    component: DashboardLayout,
    redirect: "/page/list",
    children: [
      {
        path: "list",
        name: "Pages",
        component: IndexPages,
        meta: { requiresAuth: true }
      },
      {
        path: "content",
        name: "PageContent",
        component: PageContent,
        meta: { requiresAuth: true }
      },
      {
        path: "edit",
        name: "PageContentEdit",
        component: PageContentEdit,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: "/forms",
    component: DashboardLayout,
    redirect: "/forms/list",
    children: [
      {
        path: "list",
        name: "FormBuilder",
        component: Forms,
        meta: { requiresAuth: true }
      },
      {
        path: "builder",
        name: "CreateForm",
        component: FormBuilder,
        meta: { requiresAuth: true }
      },
      {
        path: "edit/:id",
        name: "EditForm",
        component: EditForm,
        meta: { requiresAuth: true }
      },

      {
        path: "/userFormList/:id",
        name: "UserForm",
        component: UserForm,
        meta: { requiresAuth: true }
      },
      {
        path: "/ViewAnswer/:id",
        name: "ViewAnswer",
        component: ViewAnswer,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: "/files",
    component: DashboardLayout,
    redirect: "/files/manager",
    children: [
      {
        path: "manager",
        name: "FileManager",
        component: FileManager,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: "/pageTemplate",
    component: DashboardLayout,
    redirect: "/pageTemplate/list",
    children: [
      {
        path: "list",
        name: "PageBuilderIndex",
        component: PageBuilderIndex,
        meta: { requiresAuth: true }
      },
      {
        path: "create",
        name: "CreatePageTemplate",
        component: CreatePageTemplate,
        meta: { requiresAuth: true }
      },
      {
        path: "edit",
        name: "EditPageTemplate",
        component: EditPageTemplate,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: "/users",
    component: DashboardLayout,
    redirect: "/users/fields",
    children: [
      {
        path: "fields",
        name: "UserFields",
        component: UserFields,
        meta: { requiresAuth: true }
      },
      {
        path: "fields/create",
        name: "CreateUserFields",
        component: CreateUserFields,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: "/categories",
    component: DashboardLayout,
    redirect: "/categories/list",
    children: [
      {
        path: "list",
        name: "Categories",
        component: CategoryList,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: "/users",
    component: DashboardLayout,
    redirect: "/users/list",
    children: [
      {
        path: "list",
        name: "Users",
        component: Users,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: "/trainer",
    component: DashboardLayout,
    redirect: "/trainer/list",
    children: [
      {
        path: "list",
        name: "Trainer",
        component: ReportTrainer,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: "/crops",
    component: DashboardLayout,
    redirect: "/crops/list",
    children: [
      {
        path: "list",
        name: "Crops",
        component: Crops,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: "/country",
    component: DashboardLayout,
    redirect: "/country/list",
    children: [
      {
        path: "list",
        name: "Country",
        component: CountryCrops,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: "/packages",
    component: DashboardLayout,
    redirect: "/packages/list",
    children: [
      {
        path: "list",
        name: "Packages",
        component: Packages,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/import',
    component: DashboardLayout,
    redirect: "/import/farmers",
    children: [
      {
        path: "farmers",
        name: "ImportFarmers",
        component: ImportFarmers,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: "/report",
    component: DashboardLayout,
    redirect: "/report/page",
    children: [
      {
        path: "page",
        name: "Report",
        component: Report,
        meta: { requiresAuth: true }
      },
      {
        path: "/report/activation",
        name: "Activation",
        component: Activation,
        meta: { requiresAuth: true }
      },
      {
        path: "/report/farmers",
        name: "ReportFarmers",
        component: Farmers,
        meta: { requiresAuth: true }
      },
      {
        path: "/report/farmers/details",
        name: "FarmersDetails",
        component: FarmersDetails,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/report/harvest",
        name: "Harvest",
        component: Harvests,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/report/trainer",
        name: "ReportTrainer",
        component: ReportTrainer,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/report/trainer/details",
        name: "TrainerDetail",
        component: TrainerDetails,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/report/soilscans",
        name: "Soilscans",
        component: Soilscans,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/report/soil/show/list",
        name: "ShowList",
        component: SoilShowList,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/report/soil/view/list",
        name: "ViewSoilList",
        component: ViewSoilList,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/report/show/soil/map",
        name: "ShowMap",
        component: ShowSoilMap,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/report/show/soil/advise",
        name: "SoilAdvise",
        component: SoilAdvise,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  

  loginPage,
  RequestPasswordChangePage,
  ResetPasswordPage,
  registerPage,
  { path: "*", component: NotFound }
];

export default routes;
